$(document).ready(function () {

	$('.reviews-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		nextArrow: '<div class="slick-next icon-right"></div>',
		prevArrow: '<div class="slick-prev icon-left"></div>',
		responsive: [
			{
			breakpoint: 992,
			settings: {
				arrows: false,
				dots: true,
			}
			}
		]
	});

	$('.open-add-review').click(function(){
		$('.add-review-popup').fadeIn(300);
		$('.add-review-popup .close-popup, .add-review-blackboard').click(function(){
			$('.add-review-popup').fadeOut(300);
			setTimeout(function(){
				$('.add-review-content').removeClass('success');
			},300)
		})
	})


	$('.star-rating.editable li').click(function(){
		var elem   = $(this),
			parent = elem.parent(),
			items  = parent.find('li'),
			bar    = parent.find('.bar'),
			index  = items.index(elem),
			active = items.slice(0, index + 1);

			parent.removeClass('error');
			items.removeClass('active');
			active.addClass('active');
			
		if(bar){
			bar.css( 'width', (20 * (index + 1)) + '%' );
		}
	})

	$('.add-review-popup-btn').click(function(){
		event.preventDefault();
		var rating = $('.add-review-content .star-rating');
		if(rating.find('.active').length == 0){
			rating.addClass('error');
		}else{
			rating.removeClass('error');
		}
		$('.add-review-content .required').each(inputCheck);

		var errors = $('.add-review-content .error').length;
		if(errors == 0){
			var result = {
				'rating' : rating.find('.active').length,
				'review'	 : $('#review-text').val()
			}

			loader_on();
			sendAjax('add_reviews', result, function(res){
				setTimeout(function(){
					$('.add-review-content').addClass('success');
					setTimeout(function(){
						$('.add-review-content .star-rating .bar').css('width', '0%');
						$('.add-review-content .star-rating li').removeClass('active');
						$('#review-text').val('');
						$('#review-checkbox').prop('checked', false);
						startMasks();
					}, 300)
				},300)		
			});
			
		}

	})

});